var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
var PopoverPosition = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  position: relative;\n"], ["\n  ", "\n  position: relative;\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (!isOpen ? "display: none;" : "");
});
var PopoverContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 3px;\n  position: absolute;\n  top: 100%;\n  ", ": 0;\n"], ["\n  border-radius: 3px;\n  position: absolute;\n  top: 100%;\n  ", ": 0;\n"])), function (_a) {
    var leftToRight = _a.leftToRight;
    return (leftToRight ? "left" : "right");
});
export var Popover = function (_a) {
    var children = _a.children, anchorId = _a.anchorId, isOpen = _a.isOpen, _b = _a.position, position = _b === void 0 ? "left-to-right" : _b, toggleFn = _a.toggleFn, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var _c = useState(document.getElementById(anchorId)), container = _c[0], setContainer = _c[1];
    var _d = useState(true), isHovered = _d[0], setHovered = _d[1];
    var _e = useState(null), hideTimeout = _e[0], setHideTimout = _e[1];
    useEffect(function () {
        if (!isHovered) {
            toggleFn(false);
            setHovered(true);
        }
    }, [isHovered, toggleFn]);
    useEffect(function () {
        if (container === null) {
            setTimeout(function () { return setContainer(document.getElementById(anchorId)); }, 100);
        }
    }, [container, anchorId]);
    var handleMouseEnter = useCallback(function (e) {
        if (hideTimeout !== null) {
            clearTimeout(hideTimeout);
        }
        setHovered(true);
        if (onMouseEnter) {
            onMouseEnter(e);
        }
    }, [onMouseEnter, hideTimeout]);
    var handleMouseLeave = useCallback(function (e) {
        if (onMouseLeave) {
            onMouseLeave(e);
        }
        else {
            if (hideTimeout !== null) {
                clearTimeout(hideTimeout);
            }
            setHideTimout(setTimeout(function () {
                setHovered(false);
            }, 800));
        }
    }, [onMouseLeave, hideTimeout]);
    if (container === null) {
        return null;
    }
    return createPortal(React.createElement(PopoverPosition, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, isOpen: isOpen },
        React.createElement(PopoverContent, { leftToRight: position === "left-to-right" }, children)), container);
};
var templateObject_1, templateObject_2;
